import error_children from './errors'

const full_pages = [
    // =============================================================================
    // PAGES
    // =============================================================================
    {
        name: 'login',
        path: '/account',
        redirect: '/account/login',
        meta: {
            require_auth: false,
            title: 'Login',
            slug: 'account',
            icon: 'LogInIcon',
            searchable: false,
            param_restrictions: {}
        }
    },
    {
        path: '/account/:action',
        name: 'auth',
        meta: {
            require_auth: false,
            title: 'Login',
            slug: 'account',
            icon: 'LogInIcon',
            searchable: false,
            param_restrictions: {
                action: ['login', 'reset', 'register', 'verify', 'forgot', 'activate']
            }
        },
        component: () => import('@/views/login/Login.vue')
    },
    ...error_children
]

export default full_pages
